export type BatteryStatusType = {
  [key in BATTERY_STATUS]: string;
};

export enum WHOLE_NUMBERS {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14,
  FIFTEEN = 15,
}

export const ASSET_GATEWAY: string = $localize`Asset Gateway`;
export const ASSET_GATEWAY_MINI: string = $localize`Asset Gateway Mini`;
export const ODOMETER_WARNING_MESSAGE: string = $localize`Odometer is no longer updating due to the lack of an assigned Asset Gateway.`;
export const ENGINE_HOUR_WARNING_MESSAGE: string = $localize`Engine Hours is no longer updating due to the lack of an assigned Asset Gateway.`;

export enum AG_MODELS {
  AG_31 = 'AG-31',
  AG_55 = 'AG-55',
}

export enum BATTERY_STATUS {
  OK = 'OK',
  LOW = 'LOW',
}

export enum CHECK_IN_RATE_KEYS {
  CHECK_IN = 'CHECK_IN',
  ADDITIONAL_CHECK_IN = 'ADDITIONAL_CHECK_IN',
}

export enum AG_PING_MESSAGE_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export type IMotionDetectionStatesMapping = {
  [key in string]: string;
};

export const MOTION_DETECTION_STATES_MAPPING: IMotionDetectionStatesMapping = {
  Enabled: $localize`Enabled`,
  Disabled: $localize`Disabled`,
};

export const BATTERY_STATUS_MAPPING: BatteryStatusType = {
  [BATTERY_STATUS.OK]: $localize`Ok`,
  [BATTERY_STATUS.LOW]: $localize`Low`,
};
